<template>
  <v-container class="v-sheet-main-container dashboard elevation-12">
    <v-toolbar flat class="v-toolbar-custom">
      <v-toolbar-title>Création de comptes</v-toolbar-title>
    </v-toolbar>
    <v-sheet class="border-main-content custom-center elevation-3">
      <form>
        <div>
          <v-text-field outlined rounded color="rgb(var(--connection-rgb))" v-model="id" v-on:keyup.enter="createAccount" label="Identifiant"></v-text-field>
          <br>
          <v-text-field outlined rounded color="rgb(var(--connection-rgb))" v-model="email" v-on:keyup.enter="createAccount" label="Email (optionnel)"></v-text-field>
          <br>
          <v-text-field outlined rounded color="rgb(var(--connection-rgb))" v-model="password" type="password" label="Mot de passe" v-on:keyup.enter="createAccount"></v-text-field>
          <br>
          <v-btn x-large block outlined rounded class="title font-italic font-weight-medium custom-valid-btn connection" @click="createAccount">Créer le compte</v-btn>
        </div>
      </form>
    </v-sheet>
  </v-container>
</template>

<script>
import LoginService from '@/services/LoginService'

export default {
  data () {
    return {
      id: '',
      email: '',
      password:''
    }
  },
  methods: {
    async createAccount () {
      const response = await LoginService.register({
        login: this.id,
        email: this.email,
        password: this.password
      })
      
    }
  }
}
</script>

<style scoped>
</style>
